// extracted by mini-css-extract-plugin
export default {"campaignListPageAlert":"Wn7VK1L_6qAcp2lofDAw","campaignListPageSearchIcon":"mdWwa9Kcg7E01IPt1eVt"};